module.exports = __webpack_public_path__ + "static/media/quotes.e256d94d.svg";